import { call, put, select, fork } from 'redux-saga/effects'
import {
  createMyLabel,
  deleteCompanyMyLabel,
  deleteMyLabel,
  putCompanyMyLabel,
  refreshSourcingAnnotationCandidates,
  updateMyLabel,
} from '../actions/sourcingAnnotation'
import {
  setInitMyLabelCondition,
  successUpdateCompanyMyLabels,
} from '../actions'
import { MyLabel, MyLabelId } from '../reducers/sourcingAnnotationCandidates'
import { addMyLabel, removeMyLabel } from '@/lib/api/company'
import * as apiClient from '@/lib/api/status'
import { fetchCompanies } from '../sagas'

type CompanyMyLabelResponse = {
  myLabels: MyLabel[]
  companyMyLabelIds: MyLabel[]
}

export function* putCompanyMyLabelRequest(
  action: ReturnType<typeof putCompanyMyLabel>
) {
  const res: Response = yield call(
    addMyLabel,
    action.payload.companyId,
    action.payload.myLabelId,
    action.payload.user
  )

  if (res.ok) {
    const body = res.json().then((body) => {
      return body as CompanyMyLabelResponse
    })
    const { companyMyLabels } = yield body

    yield put(
      successUpdateCompanyMyLabels({
        companyId: action.payload.companyId,
        companyMyLabels,
      })
    )
  } else {
    console.log('Error: updateCompanyFirstInterviewDate failed', res.status)
  }
}

export function* deleteCompanyMyLabelRequest(
  action: ReturnType<typeof deleteCompanyMyLabel>
) {
  const res: Response = yield call(
    removeMyLabel,
    action.payload.companyId,
    action.payload.myLabelId,
    action.payload.user
  )

  if (res.ok) {
    const body = res.json().then((body) => {
      return body as CompanyMyLabelResponse
    })
    const { companyMyLabels } = yield body

    yield put(
      successUpdateCompanyMyLabels({
        companyId: action.payload.companyId,
        companyMyLabels,
      })
    )
  } else {
    console.log('Error: updateCompanyFirstInterviewDate failed', res.status)
  }
}

export function* postMyLabel(action: ReturnType<typeof createMyLabel>) {
  const res: Response = yield call(apiClient.postMyLabel, action.payload.name)
  if (res.ok) {
    yield put(refreshSourcingAnnotationCandidates())
  } else {
    console.log('Error: createMyLabel')
  }
}

export function* putMyLabel(action: ReturnType<typeof updateMyLabel>) {
  const res: Response = yield call(
    apiClient.putMyLabel,
    action.payload.id,
    action.payload.name
  )
  if (res.ok) {
    yield put(refreshSourcingAnnotationCandidates())
  } else {
    console.log('Error: updateMyLabel')
  }
}

export function* execDeleteMyLabel(action: ReturnType<typeof deleteMyLabel>) {
  const myLabelId = action.payload.id
  const res: Response = yield call(apiClient.deleteMyLabel, myLabelId)
  if (res.ok) {
    yield put(refreshSourcingAnnotationCandidates())
    const myLabelIds: MyLabelId[] = yield select(
      (state) => state.condition.myLabelIds
    )
    if (myLabelIds.includes(myLabelId)) {
      yield put(
        setInitMyLabelCondition(myLabelIds.filter((id) => id !== myLabelId))
      )
      yield fork(fetchCompanies)
    }
  } else {
    console.error('Error: execDeleteMyLabel')
  }
}
